import React, {Component} from "react"
import { Table, Row, Input, message } from "antd"
import Moment from "moment"
import { observer, inject } from "mobx-react"
import editAbleIcon from "app/styles/images/sp/edit.svg"
import closeIcon from "app/styles/images/sp/close.svg"
import deleteAbleIcon from "app/styles/images/sp/delete.svg"
import deleteWarningIcon from "app/styles/images/sp/delete-warning.svg"
import MaterialModal from "app/components/normal/MaterialModal"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"
import WarningTip from "app/components/normal/WarningTip/WarningTip"
import MaterialForm from "app/components/normal/MaterialForm/MaterialForm"
import MaterialFormItem from "app/components/normal/MaterialFormItem/MaterialFormItem"
import FlexableFileName from "app/components/normal/FlexableFileName"
import Highlighter from "app/components/normal/HighLighter"
import highlightable from "app/utils/highlightable"
import queryString from "query-string"
import { withRouter } from 'react-router-dom'

@inject("auth")@observer
class Index extends Component {
  constructor(props) {
    super(props)
    this.state={
      showEditModal: false,
      showDeleteModal: false,
      dataSingle: {},
      editedHistory: []
    }

    this.columns = []
  }

  componentWillReceiveProps (nextProps) {
    const { location }  = this.props
    const { location: nextLocation }  = nextProps

    if (nextLocation.search !== location.search) {
      if (nextLocation.search) {
        this.loadLimitedData(queryString.parse(nextLocation.search))
      } else {
        this.loadAllData()
      }
    }
  }

  componentDidMount() {
    let { location } = this.props
    if (location.search) {
      this.loadLimitedData(queryString.parse(location.search))
    } else {
      this.loadAllData()
    }
  }

  loadAllData () {
    const { store: { list } } = this.props
    list.getTableData()
      .then(
        res => {
          list.updateTableData(res)
          list.initPageIndex()
        }
      )
  }

  loadLimitedData (queryObj) {
    this.props.store.list.filterData(queryObj)
  }

  showEditModal = (record) => {
    this.setState({
      showEditModal: true,
      showDeleteModal: false,
      dataSingle: record,
      oldSampleName: record.sampleName
    })
  }

  showDeleteModal = (record) => {
    this.setState({
      showDeleteModal: true,
      dataSingle: record,
    })
  }

  closeModal = (modal) => {
    this.setState({
      [modal]: false
    })
  }

  changeHandle = (e, field) => {
    this.setState({
      dataSingle: {...this.state.dataSingle, [field]: e.target.value},
    })
  }

  deleteData = (dataId) => {
    const { deleteData, list } = this.props.store
    deleteData(dataId)
    .then(
      res => {
        this.setState({
          showDeleteModal: false
        })
        list.tableData = list.tableData.filter(item => item.id !== dataId)
        message.success("数据删除成功")
      },
      err => {
        message.error(err.message)
      }
    )
  }

  updateData = (dataId) => {
    const { store: { updateData, list } } = this.props
    const { dataSingle, oldSampleName } = this.state
    const newData = { sampleName: dataSingle.sampleName }

    if (!(dataSingle.sampleName || " ").trim()) {
      message.warning("样本名不能为空")
      return
    }

    if (dataSingle.sampleName === oldSampleName) {
      message.warning("新样本名与旧样本名相同，未修改")
      return
    }

    updateData(dataId, newData)
    .then(
      res => {
        this.setState({
          showEditModal: false
        })
        list.tableData = list.tableData.map(item =>
          item.id === dataId
            ? { ...item, ...newData, hasHistory: true } : item
        )
        message.success("编辑保存成功")
      },
      err => {
        message.error(err.message)
      }
    )

  }

  onPaginChange = selectedPageNumber => {
    let {
      store: {
        list
      },
    } = this.props

    list.changePagin(selectedPageNumber)

    document.getElementById("contentTop").scrollIntoView(true)
  }

  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.props.store.selectedData = selectedRows
    this.props.store.selectedRowKeys = selectedRowKeys
  }

  toggleHistory = (visible, record) => {
    if (visible) {
      // 获取数据
      const { getHistory } = this.props.store
      getHistory(record.id)
      .then(res => {
        this.setState({
          editedHistory: res
        })
      })
    } else {
      //清空拿到的数据
      this.setState({
        editedHistory: []
      })
    }
  }

  render() {
    let {
      store: {
        list: {
          tableData,
          totalCount,
          queryMap,
          currentPageIndex,
        },
        selectedRowKeys
      }
    } = this.props
    const { dataSingle } = this.state
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange
    }

    this.columns=[
      {
        title: (
          <div className="ta-l">文件名称</div>
        ),
        width: "33.71%",
        dataIndex: "filename",
        render: (filename, record, index) => {
          const { list: { queryMap: { keywords } } } = this.props.store
          return (
            <FlexableFileName filename={filename} keywords={keywords} />
          )
        }
      }, {
        title: (
          <div className="ta-l spe-title">数据样本名</div>
        ),
        dataIndex: "sampleName",
        width: "15.84%",
        render: (text, record) => {
          const { list: { queryMap: { keywords } } } = this.props.store
          const { editedHistory } = this.state

          const content = (
            <MaterialTip title={text}>
              <div className="ellipsis">
                <Highlighter
                   highlightClassName="lightlight"
                   highlightStyle={{ fontWeight: "normal" }}
                   searchWords={highlightable(text, keywords) ? [text] : []}
                   textToHighlight={text || ""}
                 />
              </div>
            </MaterialTip>
          )
          return (
            record.hasHistory
              ? <WarningTip
                  type="warningTip"
                  text={content}
                  mainKeys={["versionNum", "sampleName", "createTime"]}
                  historyData={editedHistory}
                  onVisibleChange={(visible) => this.toggleHistory(visible, record)}
                />
              : <div>
                  <Highlighter
                    highlightClassName="lightlight"
                    highlightStyle={{ fontWeight: "normal" }}
                    searchWords={highlightable(text, keywords) ? [text] : []}
                    textToHighlight={text || ""}
                  />
                </div>
          )
        }
      }, {
        title: (
          <div className="ta-r">数据大小</div>
        ),
        width:"11.2%",
        dataIndex: "size",
        render: text => {
          return text ? <div className="ta-r">{(text / 1024 / 1024).toFixed(2)}MB</div> : ""
        }
      }, {
        title: <div className="ta-c time-title">上传时间</div>,
        dataIndex: "uploadTime",
        width:"24.82%",
        sorter: (a, b) => new Date(a.uploadTime) - new Date(b.uploadTime),
        render: text => {
          return text ? <div className="ta-c">{Moment(text).format("YYYY-MM-DD HH:mm:ss")}</div> : ""
        }
      }, {
        title: "操作",
        dataIndex: "operator",
        width: 104,
        render: (text, record) => {
          return (
            <Row className="table-oprator" type="flex" justify="space-between" align="middle">
              <img
                title="修改"
                src={editAbleIcon}
                alt=""
                onClick={() => this.showEditModal(record)}
              />
              <img
                title="删除"
                src={deleteAbleIcon}
                alt=""
                onClick={() => this.showDeleteModal(record)}
              />
            </Row>
          )
        }
      }
    ]

    return(
      <div>
        <div className="wrapper-box">
          <Table
            className="datamanage-table"
            rowSelection={rowSelection}
            columns={this.columns}
            rowKey={record => record.id + "store"}
            dataSource={tableData.slice()}
            pagination={{
              pageSize: queryMap.limit,
              onChange: this.onPaginChange,
              defaultCurrent: 1,
              current: currentPageIndex,
              total: totalCount,
            }}
          />
          <MaterialModal
            className="pgs-datamanage-delete-modal"
            title="数据删除确认"
            visible={this.state.showDeleteModal}
            action={() => this.deleteData(dataSingle.id)}
            buttonText="删除"
            buttonType="danger">
            <img
              className="pgx-modal-close"
              src={closeIcon}
              alt="关闭对话框"
              onClick={()=>this.closeModal("showDeleteModal")}
            />
            <Row type="flex" justify="center" align="middle">
              {dataSingle.filename}
            </Row>
            <Row className="warning-line1" type="flex" justify="center" align="middle" gutter={8}>
              <img src={deleteWarningIcon} alt="" />
              <div>您确定要删除本条数据吗</div>
            </Row>
          </MaterialModal>
          <MaterialModal
            title="数据编辑"
            buttonText="保存"
            className="pgs-datamanage-edit-modal"
            visible={this.state.showEditModal}
            width={550}
            action={() => this.updateData(dataSingle.id)}
            buttonType="primary">
            <img
              className="pgx-modal-close"
              src={closeIcon}
              alt="关闭对话框"
              onClick={()=>this.closeModal("showEditModal")}
            />
            <MaterialForm justify="center">
              <MaterialFormItem
                labelText="文件名称"
                labelWidth={60}
              >
                <FlexableFileName filename={dataSingle.filename} />
              </MaterialFormItem>
              <MaterialFormItem
                labelWidth={60}
                labelText="样本名称"
                justify="center"
              >
                <Input
                  className="sampleName"
                  value={dataSingle.sampleName || ""}
                  onChange={(e) => this.changeHandle(e, "sampleName")}
                />
              </MaterialFormItem>
            </MaterialForm>
          </MaterialModal>
        </div>
      </div>
    )
  }
}

export default withRouter(Index)



// WEBPACK FOOTER //
// ./src/app/pages/pgs/data_manage/containers/DataTable.js